// Registers the root service worker (/sw.js). Push subscription is owned by the
// Netcore Smartech SDK (smartech('register', ...) in public/index.html), which
// subscribes with its own VAPID key. Do not call pushManager.subscribe() here:
// a second subscription with a different key unsubscribes Netcore's.
//
// /sw.js only contains the Netcore config + swv4.js, so page-side helpers live
// here. Fetch interception / offline page caching cannot be done from this file
// (it only works inside the service worker).
export default function swDev() {
  if (!('serviceWorker' in navigator)) return;

  const swUrl = `${process.env.PUBLIC_URL}/sw.js`;

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Pick up a new /sw.js on every load instead of waiting for the browser.
      registration.update().catch(() => {});

      // Show a notification when the user goes offline.
      window.addEventListener('offline', () => {
        if (
          typeof Notification !== 'undefined' &&
          Notification.permission === 'granted'
        ) {
          registration.showNotification('No Internet', {
            body: 'You are currently offline. Some features may not work.',
          });
        }
      });
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });

  // Remove the 'appV2' cache created by the old /sw.js.
  if ('caches' in window) {
    caches.delete('appV2').catch(() => {});
  }
}
